import { Amplify } from 'aws-amplify';

const configureAmplify = () => {
  Amplify.configure({
    Auth: {
      Cognito: {
        userPoolId: process.env.REACT_APP_USER_POOL_ID as string,
        userPoolClientId: process.env.REACT_APP_USER_POOL_CLIENT_ID as string,
        loginWith: {
          email: true,
        },
      },
    },
  });
};

export default configureAmplify;
